import { Container, Row, Col, Form, Button, FloatingLabel, Spinner } from 'react-bootstrap';
import Styles from '../../styles/authentication/confirmAccount.module.css';
import { useState } from 'react';
import { ConfirmAccountHelper } from '../../helpers/auth/confirm-account';
import { Helmet } from 'react-helmet';

const ConfirmAccount: React.FC = () => {
  const {
    values,
    handleChange,
    handleSubmit,
    formErrors,
    isProcessing,
  } = ConfirmAccountHelper();

  // Separate states for each label's active state
  const [emaphoActive, setEmaphoActive] = useState(false);
  const [otpActive, setOtpActive] = useState(false);

  return (
    <>
      <Helmet>
        <title>Confirm Account - Mohit's Shopping App</title>
        <meta
          name="description"
          content="Confirm your account at Mohit's Shopping App to complete your registration and start exploring the best deals on a wide range of products."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta property="og:title" content="Confirm Account - Mohit's Shopping App" />
        <meta
          property="og:description"
          content="Activate your account on Mohit's Shopping App and enjoy exclusive member benefits. Click the link in your email or confirm here."
        />
        <meta
          property="og:image"
          content={`${process.env.PUBLIC_URL}/favicon.png`}
        />
        <meta
          property="og:url"
          content="https://mohit-online-shopping.netlify.app/confirm-account"
        />
      </Helmet>

      {/* Main Heading of the Confirm Account Page */}
      <h1 className="visually-hidden">Confirm Account - Mohit's Shopping App</h1>

      <section className={Styles.confirmAccountSec}>
        <Container fluid className={Styles.container}>
          <Row className={`justify-content-end ${Styles.row}`}>
            <Col className={`d-flex align-items-center justify-content-center ${Styles.col}`} md={6}>
              <div className={Styles.formWrapper}>
                <h1>Confirm Account</h1>
                <Form onSubmit={handleSubmit}>
                  <Form.Group>
                    <FloatingLabel
                      controlId="floatingInput"
                      label="Enter Email"
                      className={`${Styles.floatingLabel} ${emaphoActive ? Styles.floatingLabelActive : ''}`}
                    >
                      {/* <Form.Control
                        type="text"
                        placeholder="Enter Email"
                        name="contact"
                        className={Styles.input}
                        autoComplete="off"  // Use camelCase for JSX
                        onFocus={() => setEmaphoActive(true)}
                        onBlur={(e) => setEmaphoActive(e.target.value !== '')}
                        value={values.contact}
                        onChange={handleChange}
                        disabled={isProcessing} // Disable when processing
                      /> */}
                      <Form.Control
                        type="text"
                        placeholder="Enter Email"
                        name="contact"
                        className={Styles.input}
                        autoComplete="off"
                        onFocus={() => setEmaphoActive(true)}
                        onBlur={(e) => setEmaphoActive(e.target.value !== '')}
                        value={values.contact}
                        onChange={handleChange}
                        disabled={true} // Make it readonly
                      />
                    </FloatingLabel>
                  </Form.Group>
                  <Form.Group>
                    <FloatingLabel
                      controlId="floatingInput"
                      label="Enter OTP"
                      className={`${Styles.floatingLabel} ${otpActive ? Styles.floatingLabelActive : ''}`}
                    >
                      <Form.Control
                        type="text"
                        placeholder="Enter OTP"
                        name="otp"
                        className={Styles.input}
                        autoComplete="off"  // Use camelCase for JSX
                        onFocus={() => setOtpActive(true)}
                        onBlur={(e) => setOtpActive(e.target.value !== '')}
                        value={values.otp}
                        onChange={handleChange}
                        disabled={isProcessing} // Disable when processing
                      />
                    </FloatingLabel>
                  </Form.Group>
                  <Button
                    type="submit"
                    // disabled={isProcessing}
                    className={Styles.confirmAccountBtn}>
                    {Object.keys(formErrors).length > 0 ? (
                      'Confirm OTP'
                    ) : isProcessing ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className={Styles.customSpinner} // Applying custom spinner styles here
                      />
                    ) : (
                      'Confirm OTP'
                    )}
                  </Button>
                  <p className={Styles.text}>
                    Please check your Email.
                  </p>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ConfirmAccount;
